// extracted by mini-css-extract-plugin
export default {"button":"FlagCell_button__2JLuQ","show":"FlagCell_show__2Aouv"};